if($('.g-container').length > -1){
  setTimeout(function(){
    Globo.FormBuilder.showMessage = function(e) {
      if (e) {
        var t = e.querySelector(".content");
        null !== t && "" != t.innerHTML && (e.style.display = "block")
        $('.g-container .footer button.submit').css('display', 'none')
      }
    }
  },1500)
}